import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import './styles/main.scss';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import PageTransition from './components/PageTransition/PageTransition';

// Page Components
import HomePage from './pages/Home/HomePage';
import WeddingsPage from './pages/Weddings/WeddingsPage';
import TeamPage from './pages/Team/TeamPage';
import ContactPage from './pages/Contact/ContactPage';
import PortfolioPage from './pages/Portfolio/PortfolioPage';
import BlogPage from './pages/Blog/BlogPage';
import BlogPost from './pages/BlogPost/BlogPost';
import PricingPage from './pages/Pricing/PricingPage';
import PrivacyPage from './pages/Privacy/PrivacyPage';
import TermsPage from './pages/Terms/TermsPage';

function AppContent() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const [menuOpen, setMenuOpen] = useState(false);

  // AnimatePresence needs to be used outside of Routes but needs access to location
  // so we create the routes inline to access menuOpen state
  return (
    <div className="App">
      <Header menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <main className="main-content">
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={
              <PageTransition>
                <HomePage menuOpen={menuOpen} />
              </PageTransition>
            } />
            <Route path="/weddings" element={
              <PageTransition>
                <WeddingsPage menuOpen={menuOpen} />
              </PageTransition>
            } />
            <Route path="/team" element={
              <PageTransition>
                <TeamPage menuOpen={menuOpen} />
              </PageTransition>
            } />
            <Route path="/contact" element={
              <PageTransition>
                <ContactPage menuOpen={menuOpen} />
              </PageTransition>
            } />
            <Route path="/portfolio" element={
              <PageTransition>
                <PortfolioPage menuOpen={menuOpen} />
              </PageTransition>
            } />
            <Route path="/blog" element={
              <PageTransition>
                <BlogPage menuOpen={menuOpen} />
              </PageTransition>
            } />
            <Route path="/blog/:id" element={
              <PageTransition>
                <BlogPost menuOpen={menuOpen} />
              </PageTransition>
            } />
            <Route path="/pricing" element={
              <PageTransition>
                <PricingPage menuOpen={menuOpen} />
              </PageTransition>
            } />
            <Route path="/privacy" element={
              <PageTransition>
                <PrivacyPage menuOpen={menuOpen} />
              </PageTransition>
            } />
            <Route path="/terms" element={
              <PageTransition>
                <TermsPage menuOpen={menuOpen} />
              </PageTransition>
            } />
          </Routes>
        </AnimatePresence>
      </main>
      {!isHomePage && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
